import { ModelBase, Property } from '@skylab-shared/core';
import { AddressModel } from '../address/address.model';
import { ClientKind } from '../client/client-kind';
import { TinKind } from '../client/tax-identification-numer-kind';

export class DocumentClientModel extends ModelBase {
    @Property(Number, { nullable: true })
    public sourceClientId: number | null;

    @Property()
    public name: string;

    @Property()
    public tinKind: TinKind;

    @Property()
    public tin: string;

    @Property()
    public kind: ClientKind;

    @Property(AddressModel, {nullable: true})
    public address: AddressModel | null;

    @Property({nullable: true})
    public emails: string[];

    @Property(String, {nullable: true})
    public internalIdentificationNumber: string | null;
}
